"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ListFilter = _interopRequireDefault(require("@/components/ListFilter"));
var _PageJumpDialog = _interopRequireDefault(require("./components/PageJumpDialog"));
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
var _enum = require("./enum");
var _fliterConfig = _interopRequireDefault(require("./fliterConfig"));
var api = _interopRequireWildcard(require("./api"));
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t6 in e) "default" !== _t6 && {}.hasOwnProperty.call(e, _t6) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t6)) && (i.get || i.set) ? o(f, _t6, i) : f[_t6] = e[_t6]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ListFilter: _ListFilter.default,
    PageJumpDialog: _PageJumpDialog.default
  },
  data: function data() {
    return _objectSpread(_objectSpread({
      pageTypeEnum: _enum.pageTypeEnum,
      listLoading: false,
      tableData: {
        list: [],
        total: 0
      },
      tableFrom: {},
      dialogVisible: false,
      submitLoading: false,
      currentRow: null,
      appMap: {}
    }, (0, _fliterConfig.default)({
      handleSearch: this.handleSearch
    })), (0, _paginationEffect.default)(this.handlerGetListData));
  },
  created: function created() {
    this.loadAppMap();
    this.handlerGetListData(this.pageData);
  },
  methods: {
    getPageTypeName: function getPageTypeName(val) {
      var item = _enum.pageTypeEnum.find(function (v) {
        return v.value === val;
      });
      return item ? item.label : '-';
    },
    loadAppMap: function () {
      var _loadAppMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, map, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return companyappApi.companyappAutoListApi();
            case 1:
              res = _context.v;
              map = {};
              (res || []).forEach(function (v) {
                map[v.id] = v.appName;
              });
              this.appMap = map;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadAppMap() {
        return _loadAppMap.apply(this, arguments);
      }
      return loadAppMap;
    }(),
    getAppNames: function getAppNames(row) {
      var _this = this;
      var ids = row.appIds || [];
      if (!ids.length) return '-';
      var names = ids.map(function (id) {
        return _this.appMap[id];
      }).filter(Boolean);
      return names.length ? names.join('、') : '-';
    },
    handleSearch: function handleSearch(data) {
      if (data) {
        var merged = _objectSpread(_objectSpread({}, this.tableFrom), data);
        Object.keys(merged).forEach(function (key) {
          if (merged[key] === '' || merged[key] === null || merged[key] === undefined) {
            delete merged[key];
          }
        });
        this.tableFrom = merged;
      } else {
        this.tableFrom = {};
      }
      this.resetPageData();
    },
    handlerGetListData: function () {
      var _handlerGetListData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, data, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.listLoading = true;
              params = _objectSpread(_objectSpread({}, this.tableFrom), this.pageData);
              _context2.p = 1;
              _context2.n = 2;
              return api.pageJumpListApi(params);
            case 2:
              data = _context2.v;
              this.tableData = data || {
                list: [],
                total: 0
              };
              this.listLoading = false;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.listLoading = false;
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handlerGetListData() {
        return _handlerGetListData.apply(this, arguments);
      }
      return handlerGetListData;
    }(),
    handleAdd: function handleAdd() {
      this.currentRow = null;
      this.dialogVisible = true;
    },
    handleEdit: function () {
      var _handleEdit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var detail, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return api.pageJumpInfoApi(row.id);
            case 1:
              detail = _context3.v;
              this.currentRow = detail || _objectSpread({}, row);
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              this.currentRow = _objectSpread({}, row);
            case 3:
              this.dialogVisible = true;
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleSubmit: function handleSubmit(formData) {
      var _this2 = this;
      this.submitLoading = true;
      var request = this.currentRow ? api.pageJumpUpdateApi : api.pageJumpCreateApi;
      var message = this.currentRow ? '编辑成功' : '新增成功';
      request(formData).then(function () {
        _this2.$message.success(message);
        _this2.dialogVisible = false;
        _this2.handlerGetListData();
      }).catch(console.error).finally(function () {
        _this2.submitLoading = false;
      });
    },
    handleSwitch: function () {
      var _handleSwitch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(row) {
        var newStatus, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              newStatus = row.status === 1 ? 0 : 1;
              _context4.p = 1;
              _context4.n = 2;
              return api.pageJumpSwitchApi(row.id, newStatus);
            case 2:
              row.status = newStatus;
              this.$message.success('状态切换成功');
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              console.error(_t4);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function handleSwitch(_x2) {
        return _handleSwitch.apply(this, arguments);
      }
      return handleSwitch;
    }(),
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm('确定删除当前数据？', '提示').then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return api.pageJumpDeleteApi(row.id);
            case 1:
              _this3.$message.success('删除成功');
              _this3.handlerGetListData();
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.error(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, null, [[0, 2]]);
      })));
    }
  }
};